import React, { useState } from 'react'
import CustomTable from '../../../customControl/CustomTable'
import CommonFilter from '../../../customControl/CommonFilter';
import { bookingDataResponse, BookingTableProps, getBookingStatusBG, getTravellerCategory } from './bookingUtils';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { useDispatch } from 'react-redux';
import { postDownloadVoucher, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { loaderActions } from '../../../_actions/loader.actions';
import FlightBookingDetailPopup from './popups/FlightBookingDetailPopup';
import HotelBookingDetailPopup from './popups/HotelBookingDetailPopup';
import { ToolTip } from '../../../components/commonClass/CommonValidation';
import HotelCancellationReason from './popups/HotelCancellationReason';
import FlightBookingRefundPopup from './popups/FlightBookingRefundPopup';
import { fetchIp } from '../../../components/commonClass/CommonFunctions';


const BookingTable = (props: BookingTableProps) => {
    const { TravelCategoryId, activeTab, activeTabName,
        BookingList, setBookingList, filteritems, userRights,
        searchvalue, setSearchValue, searchby, setSerachBy, serchdisable, getbookingdatalist
    } = props;

    const dispatch = useDispatch();
    const [bookingId, setBookingId] = useState(0);
    const [tboBookingId, setTBOBookingId] = useState(0)
    const [modalShow, setModalShow] = useState(false);
    const message = activeTab === 2 ? "Are you sure you want to confirm the booking?" : TravelCategoryId === 1 ? "Are you sure you want to approve partial cancellation request ? " : "Are you sure you want to cancel the booking?"

    const [showFlightDetailModal, setShowFlightDetailModal] = useState(false);
    const [showHotelDetailModal, setShowHotelDetailModal] = useState(false);
    const [showrefund, setShowRefund] = useState(false);
    const [flightData, setFlightData] = useState([]);
    const [refundfdata, setRefundData] = useState([]);
    const [hotelData, setHotelData] = useState([]);

    const [showCancellationReason, setShowCancellationReason] = useState<boolean>(false);
    const [cancellationReason, setCancellationReason] = useState<string>("");

    //#region column collection
    const columns = [
        {
            name: <ToolTip data="Sq. No" />,
            key: 'SrNo',
            sortable: true,
            reorder: true,
            // minWidth: '100px',
            isSearch: false,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.SrNo,
            format: (data: bookingDataResponse) => <ToolTip data={data?.SrNo} />,
        },
        {
            name: <ToolTip data="Booking ID" />,
            key: 'BookingNo',
            sortable: true,
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.BookingNo,
            format: (data: bookingDataResponse) => <ToolTip data={data?.BookingNo} />,
        },
        {
            name: <ToolTip data="Product" />,
            key: 'Product',
            sortable: true,
            reorder: true,
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.Product,
            format: (data: bookingDataResponse) => <ToolTip data={data?.Product} />,
        },
        {
            name: <ToolTip data="First Name" />,
            key: 'FirstName',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.FirstName,
            format: (data: bookingDataResponse) => <ToolTip data={data?.FirstName} />,
        },
        {
            name: <ToolTip data="Last Name" />,
            key: 'LastName',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.LastName,
            format: (data: bookingDataResponse) => <ToolTip data={data?.LastName} />,
        },
        {
            name: <ToolTip data="Contact Number" />,
            key: 'MobileNo',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.MobileNo,
            format: (data: bookingDataResponse) => <ToolTip data={data?.MobileNo} />,
        },
        {
            name: <ToolTip data="Email ID" />,
            key: 'EmailId',
            sortable: true,
            reorder: true,
            minWidth: '250px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.EmailId,
            format: (data: bookingDataResponse) => <ToolTip data={data?.EmailId} />,
        },
        {
            name: <ToolTip data="Bookings Source" />,
            key: "Source",
            sortable: true,
            reorder: true,
            minWidth: '180px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data.Source,
            omit: !(TravelCategoryId === 1 || TravelCategoryId === 5),
        },
        {
            name: <ToolTip data="Payment Status" />,
            key: 'PaymentStatusFormat',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.PaymentStatusFormat,
            format: (data: bookingDataResponse) => <ToolTip data={data?.PaymentStatusFormat} />,
        },
        {
            name: <ToolTip data="No. Of pax/traveler/Guest" />,
            key: 'NoOfTraveller',
            sortable: true,
            reorder: true,
            // minWidth: '50px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.NoOfTraveller,
            format: (data: bookingDataResponse) => <ToolTip data={data?.NoOfTraveller} />,
            omit: ((TravelCategoryId === 1 && activeTab === 5) || (TravelCategoryId === 1 && activeTab === 2) || (TravelCategoryId === 1 && activeTab === 6))
        },
        {
            name: <ToolTip data="Booking Date" />,
            key: 'CreatedDateFormat',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => new Date(data?.CreatedDate),
            format: (data: bookingDataResponse) => <ToolTip data={data?.CreatedDateFormat} />,
        },
        {
            name: activeTab !== 5 ? <ToolTip data="Journey Start Date" /> : <ToolTip data="Journey Start/Check-in Date" />,
            key: 'StartDateFormat',
            sortable: true,
            reorder: true,
            minWidth: '180px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => new Date(data?.StartDate),
            format: (data: bookingDataResponse) => <ToolTip data={data?.StartDateFormat} />,
        },
        {
            name: activeTab !== 5 ? <ToolTip data="Journey End Date" /> : <ToolTip data="Journey End/Check-out Date" />,
            key: 'EndDateFormat',
            sortable: true,
            reorder: true,
            minWidth: '180px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => new Date(data?.EndDate),
            format: (data: bookingDataResponse) => <ToolTip data={data?.EndDateFormat} />,
        },
        {
            name: activeTab !== 5 ? <ToolTip data="Booking Status" /> : <ToolTip data="Cancellation Status" />,
            key: 'BookingStatusName',
            sortable: true,
            reorder: true,
            minWidth: '180px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => data?.BookingStatusName,
            format: (data: bookingDataResponse) =>
                <div className="bookingStatus">
                    <button
                        type='button'
                        className={`btn border status ${activeTabName} ${getBookingStatusBG(data?.BookingCondition)}`}
                        style={{ opacity: 1 }}
                        title={data?.BookingStatusName || ""}
                        onClick={(e) => {
                            setBookingId(data?.BookingId);
                            setTBOBookingId(data?.TBOBookingId);
                            setModalShow(true);
                        }}
                        disabled={(TravelCategoryId !== 2 && (TravelCategoryId === 1 && activeTab !== 5)) || data?.BookingCondition === 0 || (!userRights?.UserAdd && !userRights?.UserEdit)}>
                        {data?.BookingStatusName}
                    </button>
                </div>
            ,
            omit: activeTab === 3 || activeTab === 6,
        },
        {
            name: <ToolTip data="Voucher" />,
            sortable: true,
            reorder: true,
            // minWidth: '180px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => <button type="button" className='btn p-0 text-center' title="Download Voucher" onClick={() => generateVoucher(data?.BookingId, TravelCategoryId)} > <i className="fa-solid fa-download"></i> </button>,
            omit: !((TravelCategoryId === 1 && (activeTab === 2 || activeTab === 6)) || (TravelCategoryId === 5 && (activeTab === 2 || activeTab === 6 || activeTab ===3))),
        },
        {
            name: <ToolTip data="Booking Details" />,
            sortable: true,
            reorder: true,
            minWidth: '180px',
            isSearch: true,
            isExport: true,
            selector: (data: bookingDataResponse) => <button type="button" className='btn p-0 text-center' onClick={() => openBookingDetails(data)} > <i className="fa-solid fa-eye"></i> </button>,
            omit: TravelCategoryId === 2 || (TravelCategoryId === 5 && activeTab === 9) || !(activeTab === 2 || activeTab === 6 || (TravelCategoryId === 1 && activeTab === 5)),
        },
    ]
    //#endregion


    const openBookingDetails = async (data: bookingDataResponse) => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let userip = await fetchIp();
            if (userip?.status) {

                if (TravelCategoryId === 1) {
                    const coll: any = {
                        EndUserIp: userip?.data,
                        PNR: data?.PNR,
                        BookingId: data?.TBOBookingId
                    }
                    await postUsersData('/midoffice/v1/getmoflightbookingdetails', coll).then((res) => {
                        if (res?.status) {
                            setFlightData({ ...res?.data, ...data })
                            setShowFlightDetailModal(true);
                        }
                    })
                }
                else if (TravelCategoryId === 5) {
                    const coll = {
                        EndUserIp: userip?.data,
                        BookingId: data?.TBOBookingId
                    }

                    await postUsersData('/midoffice/v1/getmohotelbookingdetails', coll).then((res) => {
                        if (res?.status) {
                            setHotelData({ ...res?.data, data })
                            setShowHotelDetailModal(true);
                        }
                    })
                }

                dispatch(loaderActions.end());
            }
            else {
                dispatch(loaderActions.end());
                dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!' });
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const handleApprove = async () => {
        const statusoftoken = await verifytoken();
        if (statusoftoken) {
            const userdata: any = GetLocalStorage()
            dispatch(loaderActions.start());
            const data = {
                BookingStatus: activeTabName === 'Upcoming' ? 2 : 5,
                BookingId: bookingId,
                UserId: userdata?.userMasterID
            }
            const updatebookingstatus = await postUsersData('/midoffice/v1/updatebookingstatus', data)
            if (updatebookingstatus?.status) {
                getbookingdatalist();
                setModalShow(false);
            }
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const getrefunddetails = async () => {
        const statusoftoken = await verifytoken();
        if (statusoftoken) {
            setModalShow(false);
            dispatch(loaderActions.start());
            const data = {
                BookingId: tboBookingId,
            }
            const res = await postUsersData('/midoffice/v1/getpartialcancellationdetails', data)
            if (res?.status) {
                setRefundData(res?.data)
                setShowRefund(true)
            }
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }

    }

    const handleConfirmation = (isConfirm: boolean) => {
        if (isConfirm === true) {
            if (TravelCategoryId !== 1) {
                handleApprove()
            }
            else {
                getrefunddetails()
            }
        }
        else {
            setModalShow(false);
        }
    }

    const handleRowClick = (data: bookingDataResponse) => {
        if ([5, 2]?.includes(TravelCategoryId) && activeTab === 5) {
            setShowCancellationReason(true);
            setCancellationReason(data?.CancellationReason);
        }
        return;
    }

    const generateVoucher = async (BookingId: number, TravelCategoryId: number) => {
        dispatch(loaderActions.start());
        const postdata = {
            BookingId: BookingId,
            TravelCategoryId: TravelCategoryId
        }
        const Response = await postDownloadVoucher('/customerui/v1/getvouchertemplatebytravelcategoryid', postdata, TravelCategoryId);
        if (!Response?.status) {
            dispatch({ type: 'ALERTING', message: Response.message });
        }
        dispatch(loaderActions.end());
    };


    return (
        <div>

            <ConfirmationModal
                show={modalShow}
                modletitle="Confirmation"
                message={message}
                onHide={() => setModalShow(false)}
                yesconfirm={() => handleConfirmation(true)}
                noconfirm={() => handleConfirmation(false)}
            />

            <CommonFilter
                filtercolumns={columns}
                filteritems={filteritems}
                setFilterList={setBookingList}
                getdata={getbookingdatalist}
                serchdisable={serchdisable}
                setSearchValue={setSearchValue}
                searchvalue={searchvalue}
                setSerachBy={setSerachBy}
                searchby={searchby}
            />

            <CustomTable
                className={`bookings ${getTravellerCategory(TravelCategoryId)} ${activeTabName}`}
                columns={columns}
                data={BookingList}
                PdfExport={false}
                ExportToExcel={false}
                disabled={!userRights?.UserExport}
                onRowClicked={(data: bookingDataResponse) => { handleRowClick(data) }}
            />


            {/* Flight Details popup  */}
            {flightData && showFlightDetailModal &&
                <FlightBookingDetailPopup flightData={flightData} show={showFlightDetailModal} setShow={setShowFlightDetailModal} activeTab={activeTab} />}

            {/* Flight Details popup  */}
            {refundfdata && showrefund &&
                <FlightBookingRefundPopup flightData={refundfdata} show={showrefund} setShow={setShowRefund} getbookingdatalist={getbookingdatalist} />}

            {/* Hotel Details popup  */}
            {hotelData && showHotelDetailModal &&
                <HotelBookingDetailPopup hotelData={hotelData} show={showHotelDetailModal} setShow={setShowHotelDetailModal} activeTab={activeTab} />}

            {/* Hotel Cancellation Reason popup */}
            <HotelCancellationReason show={showCancellationReason} setShow={setShowCancellationReason} reason={cancellationReason} />
        </div>
    )
}

export default BookingTable
